<template>
  <div class="nav-left" id="category-links">
    <ul class="side-nav-color-class">
      <div v-for="category in categories" v-bind:key="category.id" >
        <SideNavItem :active_category="active_category" :category_data="category" />
      </div>
    </ul>
  </div>
</template>

<script>
import SideNavItem from "./SideNavItem"
export default {
  props:{
    categories: Array,
    active_category: Number
  },
  components:{
    SideNavItem
  }
}
</script>

<style lang="scss">
// Left column menu
.nav-left ul li
{
	margin-left: -40px;
	list-style-type: none;
	border-bottom: 1px solid #999;
}

.nav-left ul .side-nav-link, .progress-bar-container {
	padding: 10px;
}

.nav-left ul li a
{
	color: #9f9f9f;
	font-weight: 600;
	width: 100%;
	display: block;
	padding: 10px;
}

.nav-left ul li:last-child { border-bottom: none; }

.no-padding {
	padding: 0;
}

li a span {
	padding: 10px;
}

.side-nav-color-class {
  background-color: white;
}

</style>
